<template>
  <div class="charts-two-blocks-container" style="background: #f1f5f9; margin-bottom: 10px">
    <div class="travel-flow-chart-container">
      <CustomSkeleton type="card" v-if="internalLoading" />
      <CustomChart
        v-if="foreignTouristFlow.length > 0 && !internalLoading"
        :title="'Fluxo de turistas estrangeiros'"
        :dataOptions="dataOptions"
        :legends="legends"
        :dataSets="foreignTouristFlow"
        :hasTimeFrame="true"
        :hasFilter="false"
        :hasSubtitle="false"
        :chartType="'bar'"
        :chartId="'foreign-tourist-flow-chart'"
        :indexAxis="'x'"
        :style="stylesChart"
        :stylesCustomChartButton="stylesCustomChartButton"
      />
    </div>
    <div class="travel-hostel-chart-container">
      <CustomSkeleton type="card" v-if="hotelOccupancyData.length === 0" />
      <HotelOccupancyChart
        v-if="hotelOccupancyData.length > 0"
        :title="'Ocupação Hoteleira Todas as Categorias'"
        :legends="legendsHotelOccupancy"
        :dataSets="hotelOccupancyData"
        :chartType="'bar'"
        :chartId="'travel-hostel-chart'"
        :indexAxis="'x'"
        :style="stylesChart"
      />
    </div>
  </div>
</template>

<script>
import CustomChart from '../../Components/Chart/CustomChart'
import CustomSkeleton from '@/Shared/CustomSkeleton'
import HotelOccupancyChart from './HotelOccupancyChart'
import axios from 'axios'
import { Chart, registerables } from 'chart.js'
import moment from 'moment'

Chart.register(...registerables)

export default {
  name: 'HotelOccupancyAndTouristFlow',
  components: {
    CustomChart,
    HotelOccupancyChart,
    CustomSkeleton,
  },
  props: {
    hotelOccupancy: Array,
    isLoadingAllData: Boolean,
  },
  data() {
    return {
      foreignTouristFlow: [],
      dataOptions: [],
      legends: [],
      stylesChart: {
        width: '100%',
        height: '419px',
      },
      stylesCustomChartButton: {
        'justify-content': 'flex-end',
      },
      // hotel occupancy
      legendsHotelOccupancy: [],
      hotelOccupancyData: [],
      internalLoading: this.isLoadingAllData,
    }
  },
  watch: {
    hotelOccupancy: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.processHotelOccupancy(newVal)
        }
      },
      immediate: true,
      deep: true,
    },
    isLoadingAllData: {
      handler(newVal) {
        if (!newVal) {
          this.getForeignTouristFlow()
        }
        this.internalLoading = newVal
      },
      immediate: true,
    },
  },
  methods: {
    handleTicketValueDays(id) {},
    async getForeignTouristFlow() {
      try {
        this.internalLoading = true
        const response = await axios.get('/api/transport-modes/foreign-tourist-flows')
        this.processForeignTouristFlow(response.data)
      } catch (error) {
        this.internalLoading = false
        console.error(error)
      }
    },
    processForeignTouristFlow(data) {
      const labels = [...new Set(data.map((item) => item.label))]
      this.dataOptions = labels.map((label) => ({
        label: label,
        value: label,
      }))
      this.legends = labels.map((label, index) => ({
        color: this.getColor(index),
        text: label,
      }))
      this.foreignTouristFlow = labels.map((label, index) => ({
        label: label,
        value: label,
        toolTipLegend: '',
        color: this.getColor(index),
        answers: data
          .filter((item) => item.label === label)
          .map((item) => ({
            answer_date: item.answer_date,
            answer_text: item.answer_text,
          })),
      }))
      this.internalLoading = false
    },
    getColor(index) {
      const colors = [
        '#FF6384',
        '#36A2EB',
        '#FFCE56',
        '#4BC0C0',
        '#9966FF',
        '#FF9F40',
        '#FFCD56',
        '#4D5360',
      ]
      return colors[index % colors.length]
    },
    processHotelOccupancy(data) {
      const groupedData = this.groupDataByMonth(data)

      const labels = Object.keys(groupedData).sort()
      const values = Object.values(groupedData)

      this.hotelOccupancyData = [
        {
          label: 'Ocupação Hoteleira',
          backgroundColor: '#36A2EB',
          toolTipLegend: '',
          answers: labels.map((label, index) => ({
            answer_date: label,
            answer_text: values[index],
          })),
        },
      ]
    },
    groupDataByMonth(data) {
      return data.reduce((acc, answer) => {
        let key = moment(answer.answer_date).format('YYYY-MM')
        if (!acc[key]) {
          acc[key] = 0
        }
        acc[key] += parseFloat(answer.answer_text)
        return acc
      }, {})
    },
  },
}
</script>

<style src="./styles.css"></style>
